import React from 'react'
import {
  BlockIcon,
  DealsIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  FaceIdIcon,
  LaptopIcon,
  ServicesIcon,
  SearchIcon,
  ShopIcon,
  ShoppingCartIcon,
} from '@paypalcorp/pp-react'

const dataPrivacyConfig = {
  permission: {
    icon: <ServicesIcon size="sm" color="sysColorPrimaryMain" />,
  },
  manageCookie: {
    icon: <LaptopIcon size="sm" color="sysColorPrimaryMain" />,
  },
  marketing: {
    icon: <DealsIcon size="sm" color="sysColorPrimaryMain" />,
  },
  shopping: {
    icon: <ShopIcon size="sm" color="sysColorPrimaryMain" />,
  },
  searchPrivacy: {
    icon: <SearchIcon size="sm" color="sysColorPrimaryMain" />,
  },
  blockedContacts: {
    icon: <BlockIcon size="sm" color="sysColorPrimaryMain" />,
  },
}

const sharedInfoConfig = {
  permission: {
    icon: <ServicesIcon size="sm" color="sysColorPrimaryMain" />,
  },
  recommendations: {
    icon: <ShoppingCartIcon size="sm" color="sysColorPrimaryMain" />,
  },
}

const dataPlatformConfig = {
  downloadData: {
    icon: <DownloadIcon size="sm" color="sysColorPrimaryMain" />,
    badge: {
      open: { type: 'feature', className: '' },
      progress: { type: 'feature', className: '' },
      download: { type: 'success', className: '' },
    },
  },
  correctData: {
    icon: <EditIcon size="sm" color="sysColorPrimaryMain" />,
  },
  verificationData: {
    icon: <FaceIdIcon size="sm" color="sysColorPrimaryMain" />,
  },
  deleteData: {
    icon: <DeleteIcon size="sm" color="sysColorPrimaryMain" />,
  },
}

export { dataPrivacyConfig, sharedInfoConfig, dataPlatformConfig }
